function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("circle", {
  fill: "currentColor",
  cx: 8,
  cy: 8,
  r: 8
}), React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.523273,
  d: "M2.28571429 8.08915907l4.05963675 3.77638713 7.23448086-7.29411763"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/tick.f35b8c1b.svg";
export { SvgComponent as ReactComponent };